var exports = {
  "k": "x7be19a29--8a9b4b--container",
};

module.exports = exports;
